import { combineLocationString, createURLParser, splitLocationString } from '../../../util/index';
import { Api, Http } from '../../models/index';
import { GetApi } from '../resources/api/GetApi';
import { GetLink } from '../resources/GetLink';
import { UseCase } from '../UseCase';
import { SetOAuthState } from './SetOAuthState';

export class Authenticate implements UseCase<string, Promise<void>> {
    private setOAuthState = new SetOAuthState();
    private getLink = new GetLink<Api.Rel>();
    private getApi: GetApi;

    constructor(
        http: Http,
        private location: Location = window.location
    ) {
        this.getApi = new GetApi(http);
    }

    execute(username: string): Promise<void> {
        return this.getApi.execute().then((api) => {
            const link = this.getLink.execute({ parent: api, rel: 'authenticate' });
            const html: Element = document.querySelector('html')!;

            if (link) {
                const parser = createURLParser(link.href);
                const search = splitLocationString(parser.search);
                const currentSearch = splitLocationString(this.location.search);
                search.username = username;
                search.response_type = currentSearch.response_type || 'token';
                search.client_id = currentSearch.client_id || 'mddapp';
                search.scope = currentSearch.scope || 'read write';
                // search.redirect_uri = currentSearch.redirect_uri || this.location.origin;
                search.redirect_uri = this.location.origin;
                search.redirect_path = currentSearch.redirect_path || '';
                search.state = currentSearch.state || <string>this.setOAuthState.execute();
                search.logo = (<HTMLImageElement>(
                    document.querySelector('mdd-shade .shade img')
                )).src;
                search.primaryColor = getComputedStyle(html).getPropertyValue('--primary-color');
                search.backgroundColor = getComputedStyle(html).getPropertyValue(
                    '--primary-background-color'
                );

                parser.search = combineLocationString(search);
                this.location.href = encodeURI(parser.href);
            } else {
                throw new Error('Cannot find authenticate link');
            }
        });
    }
}
